<script lang="ts">
import type {PropType} from "vue";

import {defineComponent} from "vue";
export default defineComponent({
  name: "ArrowControl",

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },

    callback: {
      type: Function as PropType<() => unknown>,
    },

    disableStop: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    async startAsyncTask() {
      if (this.loading || (this as typeof this & {disabled?: boolean}).disabled) return;

      this.loading = true

      try {
        await this.callback!()
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },

    handleClick(event: { stopPropagation: () => void; }) {
      if (!this.disableStop) {
        event.stopPropagation();
      }
      this.startAsyncTask();
    }
  }
})
</script>

<template>
  <svg viewBox="0 0 8 6" xmlns="http://www.w3.org/2000/svg" @click="handleClick">
    <path d="M3.94545 0.650391L7.84257 5.15039H0.0483398L3.94545 0.650391Z" v-if="isOpen"/>
    <path d="M3.94545 5.15039L0.0483298 0.650392L7.84256 0.650392L3.94545 5.15039Z" v-else/>
  </svg>
</template>

<style scoped lang="scss">
svg {
  width: 8px;
  height: 6px;
}
</style>